// extracted by mini-css-extract-plugin
module.exports = {"panel":"textarea_panel__o5SRj"};